const FeesIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_305_8708)">
        <circle cx="8.74996" cy="8.00008" r="6.83333" stroke="white" />
        <rect
          x="12.0834"
          y="4"
          width="0.666667"
          height="10"
          rx="0.333333"
          transform="rotate(45 12.0834 4)"
          fill="white"
        />
        <circle cx="11.0833" cy="10.3333" r="0.833333" stroke="white" />
        <circle cx="6.08333" cy="5.33333" r="0.833333" stroke="white" />
      </g>
      <defs>
        <clipPath id="clip0_305_8708">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default FeesIcon;
